<template>
    <div>
        <b-navbar toggleable="lg" type="light" variant="light">
            <b-navbar-brand href="#">Hartman Yacht Maintenance, Inc.</b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown text="Settings" right>
                        <b-dropdown-item href="#" @click="logout()">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>

import * as authservice from '../services/auth_service'
 
export default {
    
    data() {
        return {}
    },   

    methods:{             
       
       async logout() {
            try {
               const response = await authservice.logout();               
                if(response.data.success) {
                     this.deleteItemsLocalStorage();
                     this.$router.push('/login');
                }
            } catch (error) {
                console.log(error)
            }
        },

        deleteItemsLocalStorage() {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')     
            localStorage.removeItem('user')      
        },       
        
    }
}
</script>

